import { useState, useEffect } from "react";
import { Grid, Card, CardHeader, CardContent, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import Icon from "@mui/material/Icon";
import { getAuth } from "firebase/auth";
import { collection, getDocs, doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function Administrators() {
  const [administrators, setAdministrators] = useState([]);
  const navigate = useNavigate();
  const auth = getAuth();

  const columns = [
    { Header: "Nombre", accessor: "name", width: "25%" },
    { Header: "Email", accessor: "email", width: "25%" },
    { Header: "Rol", accessor: "role", width: "20%" },
    { Header: "Estado", accessor: "status", width: "15%" },
    { Header: "Acciones", accessor: "actions", width: "15%" },
  ];

  const fetchAdministrators = async () => {
    try {
      console.log("Iniciando fetchAdministrators");
      const usersRef = collection(db, "users");
      console.log("Referencia a colección users creada");
      
      const querySnapshot = await getDocs(usersRef);
      console.log("Query ejecutada, documentos obtenidos:", querySnapshot.size);
      
      const adminList = querySnapshot.docs.map(doc => {
        const data = doc.data();
        console.log("Documento:", doc.id, data);
        return {
          id: doc.id,
          ...data
        };
      });
      
      console.log("Lista de administradores procesada:", adminList);
      setAdministrators(adminList);
    } catch (error) {
      console.error("Error detallado al obtener administradores:", error);
    }
  };

  useEffect(() => {
    console.log("useEffect ejecutado");
    fetchAdministrators();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de que deseas eliminar este administrador?")) {
      try {
        await setDoc(doc(db, "users", id), { 
          deleted: true,
          deletedAt: new Date()
        }, { merge: true });
        fetchAdministrators();
      } catch (error) {
        console.error("Error deleting administrator:", error);
      }
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      await setDoc(doc(db, "users", id), { 
        status: newStatus,
        updatedAt: new Date()
      }, { merge: true });
      fetchAdministrators();
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };

  const rows = administrators.map((admin) => ({
    name: admin.name || "Sin nombre",
    email: admin.email || "Sin email",
    role: admin.role || "Sin rol",
    status: admin.status || "Sin estado",
    actions: (
      <MDBox>
        <IconButton 
          onClick={() => navigate(`/administrators/edit/${admin.id}`)}
          sx={{ color: "info.main" }}
        >
          <Icon>edit</Icon>
        </IconButton>
        <IconButton 
          onClick={() => handleToggleStatus(admin.id, admin.status)}
          sx={{ color: admin.status === "active" ? "warning.main" : "success.main" }}
        >
          <Icon>{admin.status === "active" ? "block" : "check_circle"}</Icon>
        </IconButton>
        <IconButton 
          onClick={() => handleDelete(admin.id)}
          sx={{ color: "error.main" }}
        >
          <Icon>delete</Icon>
        </IconButton>
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Administradores
                </MDTypography>
                <MDButton
                  variant="gradient"
                  color="white"
                  onClick={() => navigate("/administrators/new")}
                >
                  Nuevo Administrador
                </MDButton>
              </MDBox>
              <CardContent>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Administrators; 